import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

class TmxUploadForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fileSelectd: 0,
			uploading: 0,
			description: this.props.tmx?this.props.tmx.description:"",
			langPairId: this.props.tmx?this.props.tmx.languagePair.id:0,
			tmxFile: ''
		};
		this.handleDocument = this.handleDocument.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeLang = this.handleChangeLang.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	
	handleDocument(e) {
		this.setState({fileSelectd: 1});
		this.setState({tmxFile: e.target.files[0]});
		if(this.state.description.length==0){
			this.setState({description: e.target.files[0].name});
		}
		//console.log("Extension: "+extension+" ["+this.state.esXLIFF+"]");
	}
	
	handleChange(e) {
		e.preventDefault();
		this.setState({[e.target.name]: e.target.value });
	}
	
	handleSubmit(e) {
//		console.log("handleSubmit");
		this.setState({uploading: 1});
		this.props.uploadTmx(this.state.tmxFile, this.state.description, this.state.langPairId)
			.then(response => { return this.setState({uploading: 2});})
			.catch(err => {/*console.log(err);*/});
	}
	
	handleChangeLang(e){
//		console.log("selected "+e.target.value);
		this.setState({langPairId: parseInt(e.target.value) });
	}
	
	render() {
		let button2="";
		const disabled = !((this.state.fileSelectd>0  && this.state.langPairId>0) || this.props.tmx!=0) ;
		if (this.state.uploading>0) {
			return <div className="content_centered">UPLOADING....</div>;
		}
//		console.log("this.props.tmx:")
//		console.log(this.props.tmx)
		//if( (this.state.fileSelectd>0  && this.state.langPairId>0) || this.props.tmx!=0){
			button2=<Grid item>
						<Button disabled={disabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "12px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmit} color="primary">
							Upload
						</Button>
					</Grid>
		//}
		let languagePairs = [];
		if(typeof(this.props.langPairs)!=="undefined"){
			if(Array.isArray(this.props.langPairs)){
				this.props.langPairs.forEach((lp) => {
					if(lp.trg!==null){
						languagePairs.push(
							<Grid item xs={1}>
								<FormControlLabel value={lp.id} key={lp.id} control={<Radio />} label={lp.code} style={{ fontSize: "8px"}}/>
							</Grid>
						)
					}
				});
			}else{
				languagePairs.push(<Grid item xs={1}>
										<FormControlLabel value={this.props.langPairs.id} key={this.props.langPairs.id} control={<Radio />} label={this.props.langPairs.code} style={{ fontSize: "8px"}}/>
									</Grid>);
			}
		}
		
		return (
			<form>
			<Grid container item direction="column" alignItems="flex-start" justify="flex-start" spacing={2}>
				<Grid item>
					<h1 className="title">Upload TMX</h1>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					<RadioGroup aria-label="language" name="lp" value={this.state.langPairId} onChange={this.handleChangeLang} row>
						{languagePairs}
					</RadioGroup>
				</Grid>
				<Grid item>
					<TextField
						id="description"
						name="description"
						label="TMX name: "
						margin="normal"
						value={this.state.description}
						onChange={this.handleChange}
					/>
				</Grid>
				<Grid item container direction="row" alignItems="center" justify="flex-start" spacing={2}>
					<Grid item>
						<Paper>
							<Button label="Choose TMX" component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
							</Button>
						</Paper>
					</Grid>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					{button2}
				</Grid>
			</Grid>
			</form>
		);
	}
}

export default TmxUploadForm;